<template>
  <div class="row">
    <div class="col-12 col-lg-8 c">
        <div class="card card-body border" v-if="info">
            <h4>
                {{ info.title }}
            </h4>
            <p>
                {{info.details}}
            </p>
            <hr>
            <div v-for="input in info.inputs" :key="input.code">
                <div class="form-group" v-if="input.type == 'text'">
                  <h5 for=""><strong>{{ input.title }}</strong></h5>
                  <textarea class="form-control" v-model="input.value" placeholder="اكتب هنا..." rows="3"></textarea>
                </div>
                <div v-if="input.type == 'radio'">
                  <h5 for=""><strong>{{ input.title }}</strong></h5>
                  <div class="form-check" v-for="v in input.values" :key="v">
                    <label class="form-check-label" style="font-size: 14px">
                      <input type="radio" class="form-check-input" :name="'c'+input.code" :id="'c'+input.code" v-model="input.value" :value="v">
                      {{ v }}
                    </label>
                  </div>
                </div>
                <div v-if="input.type == 'checkbox'">
                  <h5 for=""><strong>{{ input.title }}</strong></h5>
                  <div class="form-check" v-for="v in input.values" :key="v">
                    <label class="form-check-label" style="font-size: 14px">
                      <input type="checkbox" class="form-check-input" :name="'c'+v+input.code" :id="'c'+v+input.code" v-model="input.value" :value="v">
                      {{ v }}
                    </label>
                  </div>
                </div>
                <hr>
            </div>
            <div class="col-12 text-center" @click="end()"  v-if="info">
                <button class="btn btn-success">
                    ارسال الآن
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            info: null,values: {}
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/web/asks-single', {
                user_id: window.location.href.split("/ask/")[1].split('/')[1],
                id: window.location.href.split("/ask/")[1].split('/')[0],
            }).then(function(r){
                if(r.status == 200){
                    return alert(r.response, 200)
                }
                g.info = r.response
            }).fail(function(){
                alert("فشل الاتصال بالخادم", 200)
            })
        },
        end(){
            var g = this;
            g.info.inputs = g.info.inputs.map(function(x){
                if(x.type == 'checkbox'){
                    x.value = (x.value ?? []).join(",")
                }
                return x;
            })
            $.post(api + '/user/web/asks-done', {
                user_id: window.location.href.split("/ask/")[1].split('/')[1],
                id: window.location.href.split("/ask/")[1].split('/')[0],
                inputs: JSON.stringify(g.info.inputs)
            }).then(function(r){
                if(r.status == 200){
                    return alert(r.response, 200)
                }
                alert(r.response, 100)
            }).fail(function(){
                alert("فشل الاتصال بالخادم", 200)
            })
        },
    }
}
</script>

<style>

</style>